function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shield-tick"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M7.25 8.62478L8.75 10.1248L12.125 6.74978M15.5 8.99978C15.5 12.6811 11.4845 15.3586 10.0235 16.2109C9.85745 16.3078 9.77443 16.3562 9.65726 16.3814C9.56633 16.4009 9.43367 16.4009 9.34274 16.3814C9.22557 16.3562 9.14255 16.3078 8.97651 16.2109C7.51547 15.3586 3.5 12.6811 3.5 8.99978V5.41298C3.5 4.81335 3.5 4.51353 3.59807 4.25581C3.68471 4.02814 3.82549 3.82499 4.00824 3.66393C4.21512 3.48161 4.49585 3.37634 5.0573 3.16579L9.07865 1.65779C9.23457 1.59932 9.31253 1.57008 9.39274 1.55849C9.46388 1.54821 9.53612 1.54821 9.60726 1.55849C9.68747 1.57008 9.76543 1.59932 9.92135 1.65779L13.9427 3.16579C14.5042 3.37634 14.7849 3.48161 14.9918 3.66393C15.1745 3.82499 15.3153 4.02814 15.4019 4.25581C15.5 4.51353 15.5 4.81335 15.5 5.41298V8.99978Z",
    stroke: "#87FF8C",
    style: {
      stroke: "#87FF8C",
      stroke: "color(display-p3 0.5289 0.9992 0.5477)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.2a6056b5d05006fa80bc5ef2b9122da5.svg";
export { ForwardRef as ReactComponent };